import PropTypes from "prop-types";
import { Image } from "antd";
import { UserOutlined } from "@ant-design/icons";
import cn from "../../../../utilities/tailwind-merge";
import { getEmployeeInitials } from "./employeeHelpers";

/** Photo when there is one, otherwise the employee's initials — same look as customer avatars. */
function EmployeeAvatar({ employee, src, size = 40, preview = false, className }) {
    const image = src ?? employee?.displayPicture;
    const style = { width: size, height: size, fontSize: Math.max(12, Math.round(size * 0.36)) };

    if (image) {
        return (
            <Image
                src={image}
                alt=""
                width={size}
                height={size}
                preview={preview ? { mask: false } : false}
                className={cn("rounded-full object-cover", className)}
                rootClassName="shrink-0"
            />
        );
    }

    return (
        <span
            style={style}
            className={cn(
                "inline-flex shrink-0 items-center justify-center rounded-full bg-[#EEEEFE] font-semibold text-[#5D5DF6]",
                className,
            )}
            aria-hidden="true">
            {getEmployeeInitials(employee) || <UserOutlined />}
        </span>
    );
}

EmployeeAvatar.propTypes = {
    employee: PropTypes.object,
    src: PropTypes.string,
    size: PropTypes.number,
    preview: PropTypes.bool,
    className: PropTypes.string,
};

export default EmployeeAvatar;
